import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nav nav-tabs mt-3 ps-3 pe-3"
}
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "row mb-2 p-3" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_7 = {
  for: "is_active",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_8 = { class: "col-sm-8 d-flex align-items-center" }
const _hoisted_9 = { class: "form-check form-switch" }
const _hoisted_10 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_11 = {
  for: "isPayInBlocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_14 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_15 = {
  for: "isPayOutBlocked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_16 = { class: "col-sm-8" }
const _hoisted_17 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = {
  for: "name",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_20 = { class: "col-sm-8" }
const _hoisted_21 = { class: "row mt-2" }
const _hoisted_22 = {
  for: "currency",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_23 = { class: "col-sm-8" }
const _hoisted_24 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_25 = {
  for: "dealTimeOutMin",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_26 = { class: "col-sm-8" }
const _hoisted_27 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_28 = {
  for: "minInvoiceAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_31 = {
  for: "maxInvoiceAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_32 = { class: "col-sm-8" }
const _hoisted_33 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_34 = {
  for: "minPayOutAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_35 = { class: "col-sm-8" }
const _hoisted_36 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_37 = {
  for: "maxPayOutAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_38 = { class: "col-sm-8" }
const _hoisted_39 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_40 = {
  for: "payInRequestLimitPercent",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = { class: "col-sm-8 pe-2" }
const _hoisted_43 = { class: "col-sm-2" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "col-sm-2 ps-2" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-sm-10" }
const _hoisted_49 = {
  key: 9,
  class: "row mt-2"
}
const _hoisted_50 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_51 = { class: "col-sm-8" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "text-secondary ms-2" }
const _hoisted_54 = { class: "col-sm-3 pe-1" }
const _hoisted_55 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_56 = { class: "col-sm-3 px-1" }
const _hoisted_57 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_58 = { class: "col-sm-3 px-1" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = { class: "col-sm-3 ps-1" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-sm-10" }
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = {
  for: "issuanceTimeAlertEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_66 = { class: "col-sm-8 d-flex align-items-center" }
const _hoisted_67 = { class: "form-check form-switch mb-0" }
const _hoisted_68 = { class: "row mt-2" }
const _hoisted_69 = {
  for: "issuanceTimeAlertCriticalMilliseconds",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_70 = { class: "col-sm-8" }
const _hoisted_71 = { class: "row mt-2" }
const _hoisted_72 = {
  for: "issuanceTimeAlertTgChatId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_73 = { class: "col-sm-8" }
const _hoisted_74 = {
  key: 11,
  class: "row mt-3 mb-2"
}
const _hoisted_75 = { class: "col-sm-12 d-flex justify-content-start" }
const _hoisted_76 = {
  key: 0,
  class: "badge bg-secondary ms-1"
}
const _hoisted_77 = {
  key: 12,
  class: "row mt-3 mb-2"
}
const _hoisted_78 = { class: "col-sm-12 d-flex justify-content-start" }
const _hoisted_79 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_80 = {
  for: "integrationName",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_81 = { class: "col-sm-8" }
const _hoisted_82 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_83 = { class: "col-sm-12" }
const _hoisted_84 = {
  ref: "configField",
  id: "config",
  class: "form-control",
  rows: "18"
}
const _hoisted_85 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_86 = {
  for: "payInFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_87 = { class: "col-sm-8" }
const _hoisted_88 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_89 = {
  for: "payInFeeByPaymentOption",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_90 = { class: "col-sm-8" }
const _hoisted_91 = { class: "col-sm-8 pe-2" }
const _hoisted_92 = { class: "col-sm-2" }
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = { class: "col-sm-2 ps-2" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-sm-10" }
const _hoisted_98 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_99 = {
  for: "payOutFee",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_100 = { class: "col-sm-8" }
const _hoisted_101 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_102 = {
  for: "payInRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_103 = { class: "col-sm-8" }
const _hoisted_104 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_105 = {
  for: "payOutRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_106 = { class: "col-sm-8" }
const _hoisted_107 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_108 = {
  for: "payOutFixedRate",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_109 = { class: "col-sm-8" }
const _hoisted_110 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_111 = {
  for: "payInRateShift",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_112 = { class: "col-sm-8" }
const _hoisted_113 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_114 = {
  for: "traderPayInRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_115 = { class: "col-sm-8" }
const _hoisted_116 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_117 = {
  for: "traderPayOutRateSource",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_118 = { class: "col-sm-8" }
const _hoisted_119 = {
  key: 9,
  class: "row mt-3 mb-2"
}
const _hoisted_120 = { class: "col-sm-12 d-flex justify-content-start" }
const _hoisted_121 = {
  key: 0,
  class: "badge bg-secondary ms-1"
}
const _hoisted_122 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_123 = {
  for: "trafficGroups",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_124 = {
  key: 11,
  class: "row mt-2 mb-4"
}
const _hoisted_125 = { class: "col-sm-12" }
const _hoisted_126 = { class: "row" }
const _hoisted_127 = { class: "col-sm-6 col-form-label text-capitalize-first" }
const _hoisted_128 = { class: "col-sm-2 col-form-label text-capitalize-first" }
const _hoisted_129 = { class: "col-sm-4 col-form-label text-capitalize-first text-center" }
const _hoisted_130 = { class: "col-sm-6 pe-2" }
const _hoisted_131 = { class: "col-sm-2 pe-2" }
const _hoisted_132 = ["onUpdate:modelValue", "readonly"]
const _hoisted_133 = { class: "col-sm-4" }
const _hoisted_134 = { class: "d-flex justify-content-between" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_138 = { class: "card card-body p-2 rounded-3 mt-2 mb-2" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "col-sm-4" }
const _hoisted_141 = { class: "form-label text-capitalize-first" }
const _hoisted_142 = { class: "col-sm-4" }
const _hoisted_143 = { class: "form-label text-capitalize-first" }
const _hoisted_144 = { class: "col-sm-3" }
const _hoisted_145 = { class: "form-label text-capitalize-first" }
const _hoisted_146 = { class: "col-sm-4 pe-2" }
const _hoisted_147 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_148 = { class: "col-sm-4 pe-2" }
const _hoisted_149 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_150 = { class: "col-sm-3 pe-2" }
const _hoisted_151 = ["value", "onInput", "placeholder"]
const _hoisted_152 = { class: "col-sm-1 text-end" }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = { class: "row" }
const _hoisted_155 = { class: "col-sm-12" }
const _hoisted_156 = ["onClick"]
const _hoisted_157 = { class: "row mt-1" }
const _hoisted_158 = { class: "col-sm-12" }
const _hoisted_159 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_160 = {
  for: "payOutDealLifetimeTimeout",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_161 = { class: "col-sm-4" }
const _hoisted_162 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_163 = {
  for: "isStrictPayOutDealLifetime",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_164 = { class: "col-sm-8" }
const _hoisted_165 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_166 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_167 = {
  for: "payOutDealAcceptTimeout",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_168 = { class: "col-sm-4" }
const _hoisted_169 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_170 = {
  for: "payOutDealDisputeTimeout",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_171 = { class: "col-sm-4" }
const _hoisted_172 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_173 = {
  for: "payOutDealSla",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_174 = { class: "col-sm-8" }
const _hoisted_175 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_176 = {
  for: "isSingleTakePayOutEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_177 = { class: "col-sm-8" }
const _hoisted_178 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_179 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_180 = {
  for: "payoutHolderNameHidden",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_181 = { class: "col-sm-8" }
const _hoisted_182 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_183 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_184 = {
  for: "maxBoundSumForUniqueSums",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_185 = { class: "col-sm-8" }
const _hoisted_186 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_187 = {
  for: "reusablePaymentsCountLimit",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_188 = { class: "col-sm-8" }
const _hoisted_189 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_190 = {
  for: "isWebhooksEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_191 = { class: "col-sm-8" }
const _hoisted_192 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_193 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_194 = {
  for: "isExpiredInvoiceWebhookEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_195 = { class: "col-sm-8" }
const _hoisted_196 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_197 = ["disabled"]
const _hoisted_198 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_199 = {
  for: "isDeeplinksEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_200 = { class: "col-sm-8" }
const _hoisted_201 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_202 = { class: "form-text text-muted" }
const _hoisted_203 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_204 = {
  for: "allowDuplicateInvoices",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_205 = { class: "col-sm-8" }
const _hoisted_206 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_207 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_208 = {
  for: "signatureRequired",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_209 = { class: "col-sm-8" }
const _hoisted_210 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_211 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_212 = {
  for: "defaultPaymentOption",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_213 = { class: "col-sm-8" }
const _hoisted_214 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_215 = {
  for: "defaultPaymentSystem",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_216 = { class: "col-sm-8" }
const _hoisted_217 = {
  key: 9,
  class: "row mt-2"
}
const _hoisted_218 = {
  for: "allowedPaymentOptions",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_219 = { class: "col-sm-8" }
const _hoisted_220 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_221 = {
  for: "allowedPaymentMethod",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_222 = { class: "col-sm-8" }
const _hoisted_223 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_224 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_225 = {
  key: 11,
  class: "row mt-2"
}
const _hoisted_226 = {
  for: "blacklistPaymentMethods",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_227 = { class: "col-sm-8" }
const _hoisted_228 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_229 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_230 = {
  key: 12,
  class: "row mt-2"
}
const _hoisted_231 = {
  for: "allowedPayoutMethods",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_232 = { class: "col-sm-8" }
const _hoisted_233 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_234 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_235 = {
  key: 13,
  class: "row mt-2"
}
const _hoisted_236 = {
  for: "isOnlySingleConcurrentDealAllowedForUser",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_237 = { class: "col-sm-8" }
const _hoisted_238 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_239 = {
  key: 14,
  class: "row mt-2"
}
const _hoisted_240 = {
  for: "isUserWhitelistEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_241 = { class: "col-sm-8" }
const _hoisted_242 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_243 = {
  key: 15,
  class: "row mt-2"
}
const _hoisted_244 = {
  for: "userWhitelistText",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_245 = { class: "col-sm-8" }
const _hoisted_246 = { class: "form-text text-muted" }
const _hoisted_247 = {
  key: 16,
  class: "row mt-2"
}
const _hoisted_248 = {
  for: "stripRequisitesSpaces",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_249 = { class: "col-sm-8" }
const _hoisted_250 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_251 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_252 = {
  for: "flowType",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_253 = { class: "col-sm-8" }
const _hoisted_254 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_255 = {
  for: "isTrxIdRequiredForConfirm",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_256 = { class: "col-sm-8" }
const _hoisted_257 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_258 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_259 = {
  for: "hideUploadReceipt",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_260 = { class: "col-sm-8" }
const _hoisted_261 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_262 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_263 = {
  for: "receiptPdfRequired",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_264 = { class: "col-sm-8" }
const _hoisted_265 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_266 = {
  key: 0,
  class: "form-text text-warning"
}
const _hoisted_267 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_268 = {
  for: "showTpayWarning",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_269 = { class: "col-sm-8" }
const _hoisted_270 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_271 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_272 = {
  for: "vietQrMobileSaveFlow",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_273 = { class: "col-sm-8" }
const _hoisted_274 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_275 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_276 = {
  for: "vietQrVndAmountWarning",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_277 = { class: "col-sm-8" }
const _hoisted_278 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_279 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_280 = {
  for: "requestUserPhone",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_281 = { class: "col-sm-8" }
const _hoisted_282 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_283 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_284 = {
  for: "paymentPageLayout",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_285 = { class: "col-sm-8" }
const _hoisted_286 = ["value"]
const _hoisted_287 = { value: "" }
const _hoisted_288 = ["value"]
const _hoisted_289 = {
  key: 0,
  class: "form-text text-muted d-block"
}
const _hoisted_290 = { class: "form-text text-muted" }
const _hoisted_291 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_292 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_293 = ["src"]
const _hoisted_294 = {
  key: 9,
  class: "row mt-3"
}
const _hoisted_295 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_296 = {
  key: 0,
  class: "badge bg-warning text-dark ms-1"
}
const _hoisted_297 = { class: "col-sm-8" }
const _hoisted_298 = { class: "d-flex flex-wrap gap-2 mb-2" }
const _hoisted_299 = { class: "payment-page-banks-list" }
const _hoisted_300 = ["for"]
const _hoisted_301 = ["id", "value"]
const _hoisted_302 = { class: "form-text text-muted" }
const _hoisted_303 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_304 = {
  for: "disputeOpeningPeriod",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_305 = { class: "col-sm-4" }
const _hoisted_306 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_307 = {
  for: "isDisputeReopenAllowed",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_308 = { class: "col-sm-8" }
const _hoisted_309 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_310 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_311 = {
  for: "isDisputeAmountChecked",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_312 = { class: "col-sm-8" }
const _hoisted_313 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_314 = {
  key: 3,
  class: "row mt-2"
}
const _hoisted_315 = {
  for: "isDisputeOnCompletedDealsAllowed",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_316 = { class: "col-sm-8" }
const _hoisted_317 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_318 = {
  key: 4,
  class: "row mt-2"
}
const _hoisted_319 = {
  for: "isDisputeOpeningByApiDisabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_320 = { class: "col-sm-8" }
const _hoisted_321 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_322 = {
  key: 5,
  class: "row mt-2"
}
const _hoisted_323 = {
  for: "isAdminOnlyDisputeOnCompleted",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_324 = { class: "col-sm-8" }
const _hoisted_325 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_326 = {
  key: 6,
  class: "row mt-2"
}
const _hoisted_327 = {
  for: "disputeAutoclosePeriod",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_328 = { class: "col-sm-4" }
const _hoisted_329 = {
  key: 7,
  class: "row mt-2"
}
const _hoisted_330 = {
  for: "isAutoDisputeOnExpireEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_331 = { class: "col-sm-8" }
const _hoisted_332 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_333 = {
  key: 8,
  class: "row mt-2"
}
const _hoisted_334 = {
  for: "isCancelOnDisputeAutocloseEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_335 = { class: "col-sm-8" }
const _hoisted_336 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_337 = {
  key: 9,
  class: "row mt-2"
}
const _hoisted_338 = {
  for: "isExpiredOnDealTimeoutEnabled",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_339 = { class: "col-sm-8" }
const _hoisted_340 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_341 = {
  key: 10,
  class: "row mt-2"
}
const _hoisted_342 = {
  for: "isAutoDisputeOnExpireReceiptRequired",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_343 = { class: "col-sm-8" }
const _hoisted_344 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_345 = ["disabled"]
const _hoisted_346 = {
  key: 11,
  class: "row mt-2"
}
const _hoisted_347 = {
  for: "autoDisputeOnExpirePeriod",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_348 = { class: "col-sm-4" }
const _hoisted_349 = ["disabled"]
const _hoisted_350 = {
  key: 12,
  class: "row mt-2"
}
const _hoisted_351 = {
  for: "nightShiftHours",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_352 = { class: "col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", null, [
    (_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link pe-2 ps-2", {active: _ctx.activeTab === tab}]),
                onClick: _withModifiers(($event: any) => (_ctx.activeTab = tab), ["prevent"]),
                "aria-current": "page",
                href: "#"
              }, _toDisplayString(_ctx.$t(`store_form.tabs.${value}`)), 11, _hoisted_3)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.main ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans("labels.is_active")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isActive) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "is_active"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isActive]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.isPayInBlocked")), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.isPayInBlocked) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isPayInBlocked"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isPayInBlocked]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans("labels.isPayOutBlocked")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.isPayOutBlocked) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isPayOutBlocked"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isPayOutBlocked]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.helper.trans("labels.name")), 1),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                type: "text",
                class: "form-control",
                id: "name"
              }, null, 512), [
                [_vModelText, _ctx.form.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.helper.trans("labels.currency")), 1),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Multiselect, {
                id: "currency",
                class: "",
                modelValue: _ctx.form.currency,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.currency) = $event)),
                options: _ctx.store.getters['currencyMethods/currencies'],
                "custom-label": (opt) => `${opt}`,
                multiple: false,
                "select-label": "Select",
                placeholder: ""
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.helper.trans("labels.dealTimeOutMin")), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.dealTimeOutMin) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "dealTimeOutMin",
                          "data-maska": "99",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 2), [
                          [_vModelText, _ctx.form.dealTimeOutMin],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.helper.trans("labels.min_pay_in_amount")), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.minPayInAmount) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "minInvoiceAmount",
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": ""
                        }, null, 2), [
                          [_vModelText, _ctx.form.minPayInAmount],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.helper.trans("labels.max_pay_in_amount")), 1),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.maxPayInAmount) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "maxInvoiceAmount",
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": ""
                        }, null, 2), [
                          [_vModelText, _ctx.form.maxPayInAmount],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.helper.trans("labels.min_pay_out_amount")), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.minPayOutAmount) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "minPayOutAmount",
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": ""
                        }, null, 2), [
                          [_vModelText, _ctx.form.minPayOutAmount],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.helper.trans("labels.max_pay_out_amount")), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.maxPayOutAmount) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "maxPayOutAmount",
                          "data-maska": "9 99#",
                          "data-maska-tokens": "9:[0-9]:repeated",
                          "data-maska-reversed": ""
                        }, null, 2), [
                          [_vModelText, _ctx.form.maxPayOutAmount],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.helper.trans("labels.payInRequestLimitPercent")), 1),
                _createElementVNode("div", _hoisted_41, [
                  _cache[83] || (_cache[83] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("small", { class: "text-secondary ms-2" }, "0% - отключить выдачу, 100% - без ограничений")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.payInRequestLimits, (limit, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-1",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_Multiselect, {
                          class: "multiselect-sm",
                          modelValue: limit.option,
                          "onUpdate:modelValue": ($event: any) => ((limit.option) = $event),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          "select-label": "Select",
                          placeholder: "",
                          "open-direction": "bottom",
                          multiple: false,
                          searchable: true,
                          "internal-search": true,
                          "clear-on-select": true,
                          "close-on-select": true,
                          "options-limit": 100,
                          limit: 1000,
                          "show-no-results": false,
                          "hide-selected": true
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "custom-label"])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((limit.value) = $event),
                          type: "text",
                          class: "form-control form-control-sm",
                          "data-maska": "999",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 8, _hoisted_44), [
                          [_vModelText, limit.value],
                          [_directive_maska]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.removeLimit(index)), ["prevent"]),
                          class: "btn btn-sm btn-outline-danger text-nowrap"
                        }, _cache[82] || (_cache[82] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_46)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.addLimit()), ["prevent"])),
                        class: "btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap"
                      }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.payInRequestLimitsByAmountEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.helper.trans("labels.payInRequestLimitByAmount")), 1),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("small", _hoisted_53, _toDisplayString(_ctx.helper.trans("labels.payInRequestLimitByAmountHint")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.payInRequestLimitsByAmount, (range, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-1",
                      key: 'amount-limit-' + index
                    }, [
                      _createElementVNode("div", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((range.minSum) = $event),
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.amountFrom')
                        }, null, 8, _hoisted_55), [
                          [_vModelText, range.minSum]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((range.maxSum) = $event),
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.amountTo')
                        }, null, 8, _hoisted_57), [
                          [_vModelText, range.maxSum]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((range.value) = $event),
                          type: "text",
                          class: "form-control form-control-sm",
                          "data-maska": "999",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 8, _hoisted_59), [
                          [_vModelText, range.value],
                          [_directive_maska]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.removePayInRequestLimitByAmount(index)), ["prevent"]),
                          class: "btn btn-sm btn-outline-danger text-nowrap"
                        }, _cache[84] || (_cache[84] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_61)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.addPayInRequestLimitByAmount()), ["prevent"])),
                        class: "btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap"
                      }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canManageIssuanceAlert)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.helper.trans('store.issuance_time_alert.enabled')), 1),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.issuanceTimeAlertEnabled) = $event)),
                        class: "form-check-input",
                        type: "checkbox",
                        id: "issuanceTimeAlertEnabled"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.issuanceTimeAlertEnabled]
                      ])
                    ])
                  ])
                ]),
                (_ctx.form.issuanceTimeAlertEnabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.helper.trans('store.issuance_time_alert.critical_time')), 1),
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_FormInputWrapper, {
                            errors: _ctx.getIssuanceAlertErrors('issuanceTimeAlertCriticalMilliseconds')
                          }, {
                            default: _withCtx((parentProps) => [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.issuanceTimeAlertCriticalMilliseconds) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "issuanceTimeAlertCriticalMilliseconds",
                                style: {"max-width":"140px"},
                                placeholder: "10000"
                              }, null, 2), [
                                [_vModelText, _ctx.form.issuanceTimeAlertCriticalMilliseconds]
                              ])
                            ]),
                            _: 1
                          }, 8, ["errors"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.helper.trans('store.issuance_time_alert.tg_chat_id')), 1),
                        _createElementVNode("div", _hoisted_73, [
                          _createVNode(_component_FormInputWrapper, {
                            errors: _ctx.getIssuanceAlertErrors('issuanceTimeAlertTgChatId')
                          }, {
                            default: _withCtx((parentProps) => [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.issuanceTimeAlertTgChatId) = $event)),
                                type: "text",
                                class: _normalizeClass(["form-control", parentProps.class]),
                                id: "issuanceTimeAlertTgChatId",
                                onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.markIssuanceTimeAlertTgChatIdDirty && _ctx.markIssuanceTimeAlertTgChatIdDirty(...args)))
                              }, null, 34), [
                                [_vModelText, _ctx.form.issuanceTimeAlertTgChatId]
                              ])
                            ]),
                            _: 1
                          }, 8, ["errors"])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.referralSettings && _ctx.form.referralSettings.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.$emit('open-referral-settings')), ["prevent"]))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.referral_store_fees')) + " ", 1),
                    (_ctx.referralOverridesCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.referralOverridesCount), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.$emit('open-settings-history')), ["prevent"]))
                  }, _toDisplayString(_ctx.helper.trans('labels.settings_history')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.config ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin && _ctx.integrationNames.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.helper.trans("labels.integrationName")), 1),
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "integrationName",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.integrationName,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.integrationName) = $event)),
                        options: _ctx.integrationNames,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("textarea", _hoisted_84, "            ", 512)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.rates ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.helper.trans("labels.pay_in_fee_percent")), 1),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.payInFee) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payInFee",
                          "data-maska": "99.99",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payInFee],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.geoFeeEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.helper.trans("labels.payInFeeByPaymentOption")), 1),
                _createElementVNode("div", _hoisted_90, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.payInFeeByPaymentOption ?? [], (row, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-1",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_Multiselect, {
                          class: "multiselect-sm",
                          modelValue: row.option,
                          "onUpdate:modelValue": ($event: any) => ((row.option) = $event),
                          options: _ctx.store.getters['currencyMethods/options'](),
                          "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                          "select-label": "Select",
                          placeholder: "",
                          "open-direction": "bottom",
                          multiple: false,
                          searchable: true,
                          "internal-search": true,
                          "clear-on-select": true,
                          "close-on-select": true,
                          "options-limit": 100,
                          limit: 1000,
                          "show-no-results": false,
                          "hide-selected": true
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "custom-label"])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((row.feePercent) = $event),
                          type: "text",
                          class: "form-control form-control-sm",
                          "data-maska": "99.99",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 8, _hoisted_93), [
                          [_vModelText, row.feePercent],
                          [_directive_maska]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _withModifiers(($event: any) => (_ctx.removePayInFeeOption(index)), ["prevent"]),
                          class: "btn btn-sm btn-outline-danger text-nowrap"
                        }, _cache[85] || (_cache[85] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_95)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.addPayInFeeOption()), ["prevent"])),
                        class: "btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap"
                      }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.helper.trans("labels.pay_out_fee_percent")), 1),
                _createElementVNode("div", _hoisted_100, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.payOutFee) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payOutFee",
                          "data-maska": "99.99",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payOutFee],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", in", 1),
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.payInRateSource,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.payInRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.helper.trans("labels.rate_source")) + ", out", 1),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.payOutRateSource,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.payOutRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.helper.trans("labels.fixedRate")), 1),
                _createElementVNode("div", _hoisted_109, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.payOutFixedRate) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payOutFixedRate"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payOutFixedRate]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.helper.trans("labels.payInRateShift")), 1),
                _createElementVNode("div", _hoisted_112, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: [],
                    class: "row"
                  }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.payInRateShift) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "payInRateShift",
                          "data-maska": "99.99",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 2), [
                          [_vModelText, _ctx.form.payInRateShift],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.helper.trans("labels.trader_rate_source")) + ", in", 1),
                _createElementVNode("div", _hoisted_115, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.traderPayInRateSource,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.traderPayInRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.helper.trans("labels.trader_rate_source")) + ", out", 1),
                _createElementVNode("div", _hoisted_118, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.traderPayOutRateSource,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.traderPayOutRateSource) = $event)),
                        options: _ctx.store.getters['rateSources/all'],
                        "custom-label": (opt) => _ctx.store.getters['rateSources/get'](opt)?.name,
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary btn-sm text-capitalize-first",
                    onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.$emit('open-cross-border-rates')), ["prevent"]))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.crossBorderRates')) + " ", 1),
                    (_ctx.form.crossBorderSettings?.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.form.crossBorderSettings.length), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.helper.trans("labels.traffic_groups")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.helper.trans('labels.title')), 1),
                    _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.helper.trans('labels.fee')), 1),
                    _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.helper.trans('labels.actions')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.trafficGroups, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-1",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_130, [
                        _createVNode(_component_Multiselect, {
                          class: "multiselect-sm",
                          modelValue: item.trafficGroup,
                          "onUpdate:modelValue": ($event: any) => ((item.trafficGroup) = $event),
                          "track-by": "id",
                          options: _ctx.store.getters['trafficGroups/list'],
                          "custom-label": (opt) => `${opt.type}: ${opt.name}${opt.publicName ? ` (${opt.publicName})` : ''}`,
                          "select-label": "Select",
                          placeholder: "",
                          "open-direction": "bottom",
                          multiple: false,
                          searchable: true,
                          "internal-search": true,
                          "clear-on-select": true,
                          "close-on-select": true,
                          "options-limit": 100,
                          limit: 1000,
                          "show-no-results": false,
                          "hide-selected": true
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "custom-label"])
                      ]),
                      _createElementVNode("div", _hoisted_131, [
                        (item.trafficGroup?.type === _ctx.Direction.PAY_IN)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.payInFee) = $event)),
                              readonly: "",
                              type: "text",
                              class: "form-control form-control-sm",
                              "data-maska": "99.99",
                              "data-maska-tokens": "9:[0-9]:optional"
                            }, null, 512)), [
                              [_vModelText, _ctx.form.payInFee],
                              [_directive_maska]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              "onUpdate:modelValue": ($event: any) => ((item.fee) = $event),
                              readonly: item.trafficGroup?.type !== _ctx.Direction.PAY_OUT,
                              type: "text",
                              class: "form-control form-control-sm",
                              "data-maska": "99.99",
                              "data-maska-tokens": "9:[0-9]:optional"
                            }, null, 8, _hoisted_132)), [
                              [_vModelText, item.fee],
                              [_directive_maska]
                            ])
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("div", _hoisted_134, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRanges(index)), ["prevent"]),
                            class: "btn btn-sm btn-outline-secondary text-nowrap me-2"
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.expandedRanges[index] ? 'fa fa-eye-slash' : 'fa fa-eye')
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.ranges')), 1)
                          ], 8, _hoisted_135),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.removeTrafficGroup(index)), ["prevent"]),
                            class: "btn btn-sm btn-outline-danger text-nowrap"
                          }, _cache[86] || (_cache[86] = [
                            _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                          ]), 8, _hoisted_136)
                        ])
                      ]),
                      (_ctx.expandedRanges[index])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.helper.trans('labels.min_sum')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_142, [
                                  _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.helper.trans('labels.max_sum')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.helper.trans('labels.fee')), 1)
                                ]),
                                _cache[87] || (_cache[87] = _createElementVNode("div", { class: "col-sm-1" }, null, -1))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.feeByDealAmount, (range, rangeIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "row mb-1",
                                  key: rangeIndex
                                }, [
                                  _createElementVNode("div", _hoisted_146, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((range.minSum) = $event),
                                      type: "text",
                                      class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                      placeholder: _ctx.helper.trans('labels.min_sum')
                                    }, null, 10, _hoisted_147), [
                                      [_vModelText, range.minSum]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_148, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((range.maxSum) = $event),
                                      type: "text",
                                      class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                      placeholder: _ctx.helper.trans('labels.max_sum')
                                    }, null, 10, _hoisted_149), [
                                      [_vModelText, range.maxSum]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_150, [
                                    _withDirectives(_createElementVNode("input", {
                                      value: range._feePercent,
                                      onInput: ($event: any) => (_ctx.updateRangeField(index, rangeIndex, '_feePercent', $event.target.value)),
                                      type: "text",
                                      class: _normalizeClass(["form-control form-control-sm", {'is-invalid': !_ctx.isRangeValid(range)}]),
                                      "data-maska": "99.99",
                                      "data-maska-tokens": "9:[0-9]:optional",
                                      placeholder: _ctx.helper.trans('labels.fee')
                                    }, null, 42, _hoisted_151), [
                                      [_directive_maska]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_152, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _withModifiers(($event: any) => (_ctx.removeRange(index, rangeIndex)), ["prevent"]),
                                      class: "btn btn-sm btn-outline-danger"
                                    }, _cache[88] || (_cache[88] = [
                                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                    ]), 8, _hoisted_153)
                                  ])
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_154, [
                                _createElementVNode("div", _hoisted_155, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _withModifiers(($event: any) => (_ctx.addRange(index)), ["prevent"]),
                                    class: "w-100 btn btn-sm btn-outline-primary text-capitalize-first"
                                  }, _toDisplayString(_ctx.helper.trans('button.add_range')), 9, _hoisted_156)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("div", _hoisted_158, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.addTrafficGroup()), ["prevent"])),
                        class: "btn w-100 btn-sm btn-outline-dark text-capitalize-first text-nowrap"
                      }, _toDisplayString(_ctx.helper.trans('button.add')), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.payouts ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                _createElementVNode("label", _hoisted_160, _toDisplayString(_ctx.helper.trans("labels.payOutDealLifetimeTimeout")), 1),
                _createElementVNode("div", _hoisted_161, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.payOutDealLifetimeTimeout) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "payOutDealLifetimeTimeout",
                    placeholder: "PT60M"
                  }, null, 512), [
                    [_vModelText, _ctx.form.payOutDealLifetimeTimeout]
                  ]),
                  _cache[89] || (_cache[89] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: PT60M", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                _createElementVNode("label", _hoisted_163, _toDisplayString(_ctx.helper.trans("labels.isStrictPayOutDealLifetime")), 1),
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("div", _hoisted_165, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.isStrictPayOutDealLifetime) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isStrictPayOutDealLifetime"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isStrictPayOutDealLifetime]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.helper.trans("labels.payOutDealAcceptTimeout")), 1),
                _createElementVNode("div", _hoisted_168, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.payOutDealAcceptTimeout) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "payOutDealAcceptTimeout",
                    placeholder: "PT5M"
                  }, null, 512), [
                    [_vModelText, _ctx.form.payOutDealAcceptTimeout]
                  ]),
                  _cache[90] || (_cache[90] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: PT5M", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                _createElementVNode("label", _hoisted_170, _toDisplayString(_ctx.helper.trans("labels.payOutDealDisputeTimeout")), 1),
                _createElementVNode("div", _hoisted_171, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.payOutDealDisputeTimeout) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "payOutDealDisputeTimeout",
                    placeholder: "PT30M"
                  }, null, 512), [
                    [_vModelText, _ctx.form.payOutDealDisputeTimeout]
                  ]),
                  _cache[91] || (_cache[91] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: PT30M", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.payOutDealSlaFeatureEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.helper.trans("labels.payOutDealSla")), 1),
                _createElementVNode("div", _hoisted_174, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.payOutDealSla) = $event)),
                    class: "form-control",
                    id: "payOutDealSla",
                    rows: "6",
                    maxlength: "4000"
                  }, null, 512), [
                    [_vModelText, _ctx.form.payOutDealSla]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.helper.trans("labels.isSingleTakePayOutEnabled")), 1),
                _createElementVNode("div", _hoisted_177, [
                  _createElementVNode("div", _hoisted_178, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.isSingleTakePayOutEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isSingleTakePayOutEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isSingleTakePayOutEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                _createElementVNode("label", _hoisted_180, _toDisplayString(_ctx.helper.trans("labels.payoutHolderNameHidden")), 1),
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("div", _hoisted_182, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.isPayoutHolderNameHidden) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "payoutHolderNameHidden"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isPayoutHolderNameHidden]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.api ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                _createElementVNode("label", _hoisted_184, _toDisplayString(_ctx.helper.trans("labels.maxBoundSumForUniqueSums")), 1),
                _createElementVNode("div", _hoisted_185, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.maxBoundSumForUniqueSums) = $event)),
                        type: "text",
                        class: "form-control",
                        id: "maxBoundSumForUniqueSums"
                      }, null, 512), [
                        [_vModelText, _ctx.form.maxBoundSumForUniqueSums]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                _createElementVNode("label", _hoisted_187, _toDisplayString(_ctx.helper.trans("labels.reusablePaymentsCountLimit")), 1),
                _createElementVNode("div", _hoisted_188, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["col-sm-3 p-0", parentProps.class])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.reusablePaymentsCountLimit) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control", parentProps.class]),
                          id: "reusablePaymentsCountLimit",
                          "data-maska": "99999",
                          "data-maska-tokens": "9:[0-9]:optional"
                        }, null, 2), [
                          [_vModelText, _ctx.form.reusablePaymentsCountLimit],
                          [_directive_maska]
                        ])
                      ], 2)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.helper.trans("labels.isWebhooksEnabled")), 1),
                _createElementVNode("div", _hoisted_191, [
                  _createElementVNode("div", _hoisted_192, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.isWebhooksEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isWebhooksEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isWebhooksEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                _createElementVNode("label", _hoisted_194, _toDisplayString(_ctx.helper.trans("labels.isExpiredInvoiceWebhookEnabled")), 1),
                _createElementVNode("div", _hoisted_195, [
                  _createElementVNode("div", _hoisted_196, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.isExpiredInvoiceWebhookEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isExpiredInvoiceWebhookEnabled",
                      disabled: !_ctx.form.isWebhooksEnabled
                    }, null, 8, _hoisted_197), [
                      [_vModelCheckbox, _ctx.form.isExpiredInvoiceWebhookEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                _createElementVNode("label", _hoisted_199, _toDisplayString(_ctx.helper.trans("labels.isDeeplinksEnabled")), 1),
                _createElementVNode("div", _hoisted_200, [
                  _createElementVNode("div", _hoisted_201, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.isDeeplinksEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDeeplinksEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isDeeplinksEnabled]
                    ])
                  ]),
                  _createElementVNode("small", _hoisted_202, _toDisplayString(_ctx.helper.trans("labels.isDeeplinksEnabledHint")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                _createElementVNode("label", _hoisted_204, _toDisplayString(_ctx.helper.trans("labels.allowDuplicateInvoices")), 1),
                _createElementVNode("div", _hoisted_205, [
                  _createElementVNode("div", _hoisted_206, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.form.allowDuplicateInvoices) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "allowDuplicateInvoices",
                      "true-value": true,
                      "false-value": false
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.allowDuplicateInvoices]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                _createElementVNode("label", _hoisted_208, _toDisplayString(_ctx.helper.trans("labels.signatureRequired")), 1),
                _createElementVNode("div", _hoisted_209, [
                  _createElementVNode("div", _hoisted_210, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.signatureRequired) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "signatureRequired"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.signatureRequired]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                _createElementVNode("label", _hoisted_212, _toDisplayString(_ctx.helper.trans("labels.defaultPaymentOption")), 1),
                _createElementVNode("div", _hoisted_213, [
                  _createVNode(_component_Multiselect, {
                    id: "defaultPaymentOption",
                    modelValue: _ctx.form.defaultPaymentOption,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.form.defaultPaymentOption) = $event)),
                    options: _ctx.store.getters['currencyMethods/options'](),
                    "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                    multiple: false,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_option')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                _createElementVNode("label", _hoisted_215, _toDisplayString(_ctx.helper.trans("labels.defaultPaymentSystem")), 1),
                _createElementVNode("div", _hoisted_216, [
                  _createVNode(_component_Multiselect, {
                    id: "defaultPaymentSystem",
                    modelValue: _ctx.form.defaultPaymentSystem,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.defaultPaymentSystem) = $event)),
                    options: ['HUMO', 'UZCARD'],
                    "custom-label": (opt) => _ctx.helper.trans(`payment_systems.${opt}`),
                    multiple: false,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_system')
                  }, null, 8, ["modelValue", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                _createElementVNode("label", _hoisted_218, _toDisplayString(_ctx.helper.trans("labels.allowedPaymentOptions")), 1),
                _createElementVNode("div", _hoisted_219, [
                  _createVNode(_component_Multiselect, {
                    id: "pay-out-methods",
                    modelValue: _ctx.form.allowedPaymentOptions,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.form.allowedPaymentOptions) = $event)),
                    options: _ctx.store.getters['currencyMethods/options'](),
                    "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.payment_options')
                  }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                _createElementVNode("label", _hoisted_221, _toDisplayString(_ctx.helper.trans("labels.allowedPaymentMethod")), 1),
                _createElementVNode("div", _hoisted_222, [
                  _createVNode(_component_Multiselect, {
                    id: "pay-out-methods",
                    modelValue: _ctx.form.allowedPaymentMethod,
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.allowedPaymentMethod) = $event)),
                    options: _ctx.methodList(),
                    "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.allowedPaymentMethodOptions')
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_223, [
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "icon",
                          method: props.option
                        }, null, 8, ["method"]),
                        _createElementVNode("span", _hoisted_224, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                _createElementVNode("label", _hoisted_226, _toDisplayString(_ctx.helper.trans("labels.blacklistPaymentMethods")), 1),
                _createElementVNode("div", _hoisted_227, [
                  _createVNode(_component_Multiselect, {
                    id: "pay-out-methods",
                    modelValue: _ctx.form.blacklistPaymentMethods,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.blacklistPaymentMethods) = $event)),
                    options: _ctx.methodList(),
                    "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.blacklistPaymentMethodsOptions')
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_228, [
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "icon",
                          method: props.option
                        }, null, 8, ["method"]),
                        _createElementVNode("span", _hoisted_229, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                _createElementVNode("label", _hoisted_231, _toDisplayString(_ctx.helper.trans("labels.allowedPayoutMethods")), 1),
                _createElementVNode("div", _hoisted_232, [
                  _createVNode(_component_Multiselect, {
                    id: "pay-out-methods",
                    modelValue: _ctx.form.allowedPayoutMethods,
                    "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.allowedPayoutMethods) = $event)),
                    options: _ctx.methodList(),
                    "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                    multiple: true,
                    "select-label": "Select",
                    placeholder: _ctx.helper.trans('labels.allowedPaymentMethodsOptions')
                  }, {
                    option: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_233, [
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "icon",
                          method: props.option
                        }, null, 8, ["method"]),
                        _createElementVNode("span", _hoisted_234, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "custom-label", "placeholder"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                _createElementVNode("label", _hoisted_236, _toDisplayString(_ctx.helper.trans("labels.isOnlySingleConcurrentDealAllowedForUser")), 1),
                _createElementVNode("div", _hoisted_237, [
                  _createElementVNode("div", _hoisted_238, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.isOnlySingleConcurrentDealAllowedForUser) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isOnlySingleConcurrentDealAllowedForUser"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isOnlySingleConcurrentDealAllowedForUser]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.userWhitelistFeatureEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                _createElementVNode("label", _hoisted_240, _toDisplayString(_ctx.helper.trans("labels.isUserWhitelistEnabled")), 1),
                _createElementVNode("div", _hoisted_241, [
                  _createElementVNode("div", _hoisted_242, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.isUserWhitelistEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isUserWhitelistEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isUserWhitelistEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.userWhitelistFeatureEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                _createElementVNode("label", _hoisted_244, _toDisplayString(_ctx.helper.trans("labels.userWhitelist")), 1),
                _createElementVNode("div", _hoisted_245, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.userWhitelistText) = $event)),
                    class: "form-control font-monospace",
                    id: "userWhitelistText",
                    rows: "6",
                    spellcheck: "false",
                    placeholder: "[\"user-1\", \"user-2\"]"
                  }, null, 512), [
                    [_vModelText, _ctx.form.userWhitelistText]
                  ]),
                  _createElementVNode("small", _hoisted_246, _toDisplayString(_ctx.helper.trans("labels.userWhitelistHint")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                _createElementVNode("label", _hoisted_248, _toDisplayString(_ctx.helper.trans("labels.stripRequisitesSpaces")), 1),
                _createElementVNode("div", _hoisted_249, [
                  _createElementVNode("div", _hoisted_250, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.stripRequisitesSpaces) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "stripRequisitesSpaces"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.stripRequisitesSpaces]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.paymentPage ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                _createElementVNode("label", _hoisted_252, _toDisplayString(_ctx.helper.trans("labels.flowType")), 1),
                _createElementVNode("div", _hoisted_253, [
                  _createVNode(_component_FormInputWrapper, { errors: [] }, {
                    default: _withCtx((parentProps) => [
                      _createVNode(_component_Multiselect, {
                        id: "parentId",
                        class: _normalizeClass(["", parentProps.class]),
                        modelValue: _ctx.form.flowType,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.flowType) = $event)),
                        options: Object.values(_ctx.FlowType),
                        "custom-label": (opt) => _ctx.helper.trans(`flow_types.${opt}`),
                        "select-label": "Select",
                        placeholder: "",
                        "open-direction": "bottom",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["class", "modelValue", "options", "custom-label"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                _createElementVNode("label", _hoisted_255, _toDisplayString(_ctx.helper.trans("labels.isTrxIdRequiredForConfirm")), 1),
                _createElementVNode("div", _hoisted_256, [
                  _createElementVNode("div", _hoisted_257, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.isTrxIdRequiredForConfirm) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isTrxIdRequiredForConfirm"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isTrxIdRequiredForConfirm]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                _createElementVNode("label", _hoisted_259, _toDisplayString(_ctx.helper.trans("labels.hideUploadReceipt")), 1),
                _createElementVNode("div", _hoisted_260, [
                  _createElementVNode("div", _hoisted_261, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.form.hideUploadReceipt) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "hideUploadReceipt"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.hideUploadReceipt]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                _createElementVNode("label", _hoisted_263, _toDisplayString(_ctx.helper.trans("labels.receiptPdfRequired")), 1),
                _createElementVNode("div", _hoisted_264, [
                  _createElementVNode("div", _hoisted_265, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.form.receiptPdfRequired) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "receiptPdfRequired"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.receiptPdfRequired]
                    ])
                  ]),
                  (_ctx.form.receiptPdfRequired && _ctx.form.hideUploadReceipt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_266, _toDisplayString(_ctx.helper.trans("labels.receiptPdfRequiredConflict")), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_267, [
                _createElementVNode("label", _hoisted_268, _toDisplayString(_ctx.helper.trans("labels.showTpayWarning")), 1),
                _createElementVNode("div", _hoisted_269, [
                  _createElementVNode("div", _hoisted_270, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.form.showTpayWarning) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "showTpayWarning"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.showTpayWarning]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_271, [
                _createElementVNode("label", _hoisted_272, _toDisplayString(_ctx.helper.trans("labels.vietQrMobileSaveFlow")), 1),
                _createElementVNode("div", _hoisted_273, [
                  _createElementVNode("div", _hoisted_274, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.form.vietQrMobileSaveFlow) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "vietQrMobileSaveFlow"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.vietQrMobileSaveFlow]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.vietQrVndAmountWarningEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_275, [
                _createElementVNode("label", _hoisted_276, _toDisplayString(_ctx.helper.trans("labels.vietQrVndAmountWarning")), 1),
                _createElementVNode("div", _hoisted_277, [
                  _createElementVNode("div", _hoisted_278, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.form.vietQrVndAmountWarning) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "vietQrVndAmountWarning"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.vietQrVndAmountWarning]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_279, [
                _createElementVNode("label", _hoisted_280, _toDisplayString(_ctx.helper.trans("labels.requestUserPhone")), 1),
                _createElementVNode("div", _hoisted_281, [
                  _createElementVNode("div", _hoisted_282, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.form.requestUserPhone) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "requestUserPhone"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.requestUserPhone]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                _createElementVNode("label", _hoisted_284, _toDisplayString(_ctx.helper.trans("labels.paymentPageLayout")), 1),
                _createElementVNode("div", _hoisted_285, [
                  _createElementVNode("select", {
                    id: "paymentPageLayout",
                    class: "form-select",
                    value: _ctx.form.paymentPageSettings?.layout ?? '',
                    onChange: _cache[63] || (_cache[63] = ($event: any) => (_ctx.onPaymentPageLayoutChange(($event.target as HTMLSelectElement).value)))
                  }, [
                    _createElementVNode("option", _hoisted_287, _toDisplayString(_ctx.helper.trans('payment_page_layouts.default')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePaymentPageLayouts, (layout) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: layout.id,
                        value: layout.id
                      }, _toDisplayString(_ctx.helper.trans('payment_page_layouts.' + layout.id)), 9, _hoisted_288))
                    }), 128))
                  ], 40, _hoisted_286),
                  (_ctx.selectedPaymentPageLayoutConditions)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_289, _toDisplayString(_ctx.selectedPaymentPageLayoutConditions), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("small", _hoisted_290, _toDisplayString(_ctx.helper.trans('labels.paymentPageLayoutHint')), 1),
                  (_ctx.selectedPaymentPageLayoutPreviews.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-outline-secondary",
                          onClick: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.openPaymentPageLayoutPreview && _ctx.openPaymentPageLayoutPreview(...args)))
                        }, [
                          _cache[92] || (_cache[92] = _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.helper.trans('payment_instructions.design_preview')), 1)
                        ]),
                        (_ctx.paymentPageLayoutPreviewVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                              _createElementVNode("img", {
                                src: _ctx.selectedPaymentPageLayoutPreviews[0].src,
                                class: "img-fluid rounded border",
                                alt: ""
                              }, null, 8, _hoisted_293)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.form.flowType === _ctx.FlowType.DEFAULT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_294, [
                _createElementVNode("label", _hoisted_295, [
                  _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.paymentPageBanks")) + " ", 1),
                  (_ctx.isPaymentPageBanksDirty)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_296, _toDisplayString(_ctx.helper.trans("labels.paymentPageBanksUnsaved")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_297, [
                  _createElementVNode("div", _hoisted_298, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-sm",
                      onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.selectAllPaymentPageBanks && _ctx.selectAllPaymentPageBanks(...args)))
                    }, _toDisplayString(_ctx.helper.trans('button.select_all')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-sm",
                      onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.clearPaymentPageBanks && _ctx.clearPaymentPageBanks(...args)))
                    }, _toDisplayString(_ctx.helper.trans('button.clear_selection')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm",
                      onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.$emit('save')))
                    }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_299, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentPageBankOptions, (method) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "payment-page-banks-item",
                        key: method,
                        for: 'paymentPageBank-' + method
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input m-0 flex-shrink-0",
                          type: "checkbox",
                          id: 'paymentPageBank-' + method,
                          value: method,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.form.paymentPageSettings.banks) = $event))
                        }, null, 8, _hoisted_301), [
                          [_vModelCheckbox, _ctx.form.paymentPageSettings.banks]
                        ]),
                        _createVNode(_component_PayMethodIcon, {
                          "icon-class": "pay-method-icon",
                          method: method
                        }, null, 8, ["method"]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('pay_methods.' + method)), 1)
                      ], 8, _hoisted_300))
                    }), 128))
                  ]),
                  _createElementVNode("small", _hoisted_302, _toDisplayString(_ctx.helper.trans('labels.paymentPageBanksHint')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.activeTab !== _ctx.Tabs.disputes ? ['d-none'] : [])
        }, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_303, [
                _createElementVNode("label", _hoisted_304, _toDisplayString(_ctx.helper.trans("labels.disputeOpeningPeriod")), 1),
                _createElementVNode("div", _hoisted_305, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.form.disputeOpeningPeriod) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "disputeOpeningPeriod",
                    placeholder: "P14D или null"
                  }, null, 512), [
                    [_vModelText, _ctx.form.disputeOpeningPeriod]
                  ]),
                  _cache[93] || (_cache[93] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: P14D", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_306, [
                _createElementVNode("label", _hoisted_307, _toDisplayString(_ctx.helper.trans("labels.isDisputeReopenAllowed")), 1),
                _createElementVNode("div", _hoisted_308, [
                  _createElementVNode("div", _hoisted_309, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.form.isDisputeReopenAllowed) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDisputeReopenAllowed"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isDisputeReopenAllowed]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_310, [
                _createElementVNode("label", _hoisted_311, _toDisplayString(_ctx.helper.trans("labels.isDisputeAmountChecked")), 1),
                _createElementVNode("div", _hoisted_312, [
                  _createElementVNode("div", _hoisted_313, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.form.isDisputeAmountChecked) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDisputeAmountChecked"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isDisputeAmountChecked]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_314, [
                _createElementVNode("label", _hoisted_315, _toDisplayString(_ctx.helper.trans("labels.isDisputeOnCompletedDealsAllowed")), 1),
                _createElementVNode("div", _hoisted_316, [
                  _createElementVNode("div", _hoisted_317, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.form.isDisputeOnCompletedDealsAllowed) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDisputeOnCompletedDealsAllowed"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isDisputeOnCompletedDealsAllowed]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_318, [
                _createElementVNode("label", _hoisted_319, _toDisplayString(_ctx.helper.trans("labels.isDisputeOpeningByApiDisabled")), 1),
                _createElementVNode("div", _hoisted_320, [
                  _createElementVNode("div", _hoisted_321, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.form.isDisputeOpeningByApiDisabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isDisputeOpeningByApiDisabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isDisputeOpeningByApiDisabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && !_ctx.form.isDisputeOnCompletedDealsAllowed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_322, [
                _createElementVNode("label", _hoisted_323, _toDisplayString(_ctx.helper.trans("labels.isAdminOnlyDisputeOnCompleted")), 1),
                _createElementVNode("div", _hoisted_324, [
                  _createElementVNode("div", _hoisted_325, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.form.isAdminOnlyDisputeOnCompleted) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAdminOnlyDisputeOnCompleted"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAdminOnlyDisputeOnCompleted]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_326, [
                _createElementVNode("label", _hoisted_327, _toDisplayString(_ctx.helper.trans("labels.disputeAutoclosePeriod")), 1),
                _createElementVNode("div", _hoisted_328, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.form.disputeAutoclosePeriod) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "disputeAutoclosePeriod",
                    placeholder: "PT30M"
                  }, null, 512), [
                    [_vModelText, _ctx.form.disputeAutoclosePeriod]
                  ]),
                  _cache[94] || (_cache[94] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: PT30M", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
                _createElementVNode("label", _hoisted_330, _toDisplayString(_ctx.helper.trans("labels.isAutoDisputeOnExpireEnabled")), 1),
                _createElementVNode("div", _hoisted_331, [
                  _createElementVNode("div", _hoisted_332, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.form.isAutoDisputeOnExpireEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAutoDisputeOnExpireEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isAutoDisputeOnExpireEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_333, [
                _createElementVNode("label", _hoisted_334, _toDisplayString(_ctx.helper.trans("labels.isCancelOnDisputeAutocloseEnabled")), 1),
                _createElementVNode("div", _hoisted_335, [
                  _createElementVNode("div", _hoisted_336, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.form.isCancelOnDisputeAutocloseEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isCancelOnDisputeAutocloseEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isCancelOnDisputeAutocloseEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && _ctx.expiredOnDealTimeoutEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_337, [
                _createElementVNode("label", _hoisted_338, _toDisplayString(_ctx.helper.trans("labels.isExpiredOnDealTimeoutEnabled")), 1),
                _createElementVNode("div", _hoisted_339, [
                  _createElementVNode("div", _hoisted_340, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.form.isExpiredOnDealTimeoutEnabled) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isExpiredOnDealTimeoutEnabled"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.isExpiredOnDealTimeoutEnabled]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_341, [
                _createElementVNode("label", _hoisted_342, _toDisplayString(_ctx.helper.trans("labels.isAutoDisputeOnExpireReceiptRequired")), 1),
                _createElementVNode("div", _hoisted_343, [
                  _createElementVNode("div", _hoisted_344, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.form.isAutoDisputeOnExpireReceiptRequired) = $event)),
                      class: "form-check-input",
                      type: "checkbox",
                      id: "isAutoDisputeOnExpireReceiptRequired",
                      disabled: !_ctx.form.isAutoDisputeOnExpireEnabled
                    }, null, 8, _hoisted_345), [
                      [_vModelCheckbox, _ctx.form.isAutoDisputeOnExpireReceiptRequired]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_346, [
                _createElementVNode("label", _hoisted_347, _toDisplayString(_ctx.helper.trans("labels.autoDisputeOnExpirePeriod")), 1),
                _createElementVNode("div", _hoisted_348, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.form.autoDisputeOnExpirePeriod) = $event)),
                    type: "text",
                    class: "form-control",
                    id: "autoDisputeOnExpirePeriod",
                    placeholder: "PT15M",
                    disabled: !_ctx.form.isAutoDisputeOnExpireEnabled
                  }, null, 8, _hoisted_349), [
                    [_vModelText, _ctx.form.autoDisputeOnExpirePeriod]
                  ]),
                  _cache[95] || (_cache[95] = _createElementVNode("small", { class: "form-text text-muted" }, "Пример: PT15M. Пусто — обычный период автозакрытия спора", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_350, [
                _createElementVNode("label", _hoisted_351, _toDisplayString(_ctx.helper.trans("labels.nightShiftHours")), 1),
                _createElementVNode("div", _hoisted_352, [
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.form.nightShiftHours,
                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.form.nightShiftHours) = $event)),
                    options: _ctx.hoursOptions,
                    multiple: true,
                    "close-on-select": false,
                    placeholder: 'Выберите часы ночной смены',
                    "custom-label": (opt) => opt
                  }, null, 8, ["modelValue", "options", "custom-label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}